import React from 'react';
import PropTypes from 'prop-types';
import Button from "react-bootstrap/Button";

const Link = (props) => {

  let {
    url = '#',
    size,
    type,
    target = '_blank',
    className = '',
    variant,
    children,
    onClick,
  } = props;

  const createLink = () => {
    switch (type) {
      case 'button' :
        return (
          <Button target={target} variant={variant} className={className} size={size} href={!onClick?url:'#'} onClick={onClick} >{children}</Button>
        );
        break;
      case 'link' :
        return (
          <a href={!onClick?url:'#'} target={target} className={className} onClick={onClick}>{children}</a>
        );
        break;
      case 'href' :
        return <>{url}</>;
        break;
      default :
        return <></>;
        break;
    }
  };

  return createLink();

};

Link.propTypes = {
  children: PropTypes.any,
  url: PropTypes.string,
  type: PropTypes.oneOf(['button', 'link']),
  variant: PropTypes.string,
  size: PropTypes.string,
  target: PropTypes.string,
  className: PropTypes.any,
  onClick: PropTypes.func,
};

export default Link;
